import { memo } from "react";
import Screen, { type ScreenProps } from "ui/layouts/Screen";
import { Applications as ApplicationsComponent } from "ui/organizms/Onboarding";

const Applications = (props: ScreenProps) => (
    <Screen
        {...props}
        title='Onboarding | Applications'
    >
        <ApplicationsComponent />
    </Screen>
);

export default memo(Applications);
